"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showNavigation = exports.DefaultHeader = exports.SHOW_NAVIGATION = void 0;
exports.SHOW_NAVIGATION = "SHOW_NAVIGATION";
exports.DefaultHeader = true;
function showNavigation(value) {
    return {
        type: [exports.SHOW_NAVIGATION],
        showNavigation: value,
    };
}
exports.showNavigation = showNavigation;
